import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type CategoryLocalizations = {
	"en-us": string;
	"de-ch": string;
	"de-de": string;
	"fr-fr": string;
	"it-it": string;
};

type UpdateCategoryPayload = {
	itemCategoryId: string;
	localizations: CategoryLocalizations;
	customSequence: number;
	defaultSequence: number;
	legacyValue: string | null;
};

const updateCategory = async (payload: UpdateCategoryPayload): Promise<any> => {
	const response = await apiDal.post("/categories/update", payload);
	return response.data;
};

export const useUpdateCategory = () => {
	return useMutation({
		mutationFn: updateCategory,
	});
};
